import React from "react";
import { useSelector } from "react-redux";
import {
  hasAlwaysRequiredPhotos,
  allRequiredPhotosUploaded
} from "../ImageUploads/helpers";
import { AllPhotosUploaded } from "../ImageUploads/components";
import {
  getImagesGroupArray,
  selectImageUploadData
} from "../../store/selectors";

export default function PhotosRequiredList({ sentences }) {
  const photosRequiredList = sentences
    .sort((a, b) => Object.keys(a) - Object.keys(b))
    .map((sentence, index) => {
      return (
        <li key={index} className="photo-intro-check-list">
          {Object.values(sentence)}
        </li>
      );
    });
  const imagesGroupArray = useSelector(getImagesGroupArray);
  const { requiredPhotoData, images } = useSelector(selectImageUploadData);

  const alwaysRequiredImages = [
    { group: "front", sentence: "of the front of the vehicle" },
    { group: "right", sentence: "of the right side of the vehicle" },
    { group: "left", sentence: "of the left side of the vehicle" },
    { group: "back", sentence: "of the back of the vehicle" },
    { group: "mileage", sentence: "of mileage" }
  ];

  return (
    <ul className="ch-list ch-list--tick">
      {alwaysRequiredImages.map((requiredImageObject) => {
        if (
          !hasAlwaysRequiredPhotos(imagesGroupArray, requiredImageObject.group)
        ) {
          return (
            <li
              className="photo-intro-check-list"
              key={requiredImageObject.group}
            >
              1 photo {requiredImageObject.sentence}
            </li>
          );
        } else {
          return null;
        }
      })}
      {photosRequiredList.sort((a, b) => Object.keys(a) - Object.keys(b))}
      {allRequiredPhotosUploaded(images, requiredPhotoData) && (
        <AllPhotosUploaded numberOfPhotosUploaded={images.length} />
      )}
    </ul>
  );
}
